import React, { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { TextFormat } from 'react-jhipster';
import { Link, useParams } from 'react-router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './estatus.reducer';

export const EstatusDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id!));
  }, []);

  const estatusEntity = useAppSelector(state => state.estatus.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="estatusDetailsHeading">Estatus</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{estatusEntity.id}</dd>
          <dt>
            <span id="idMensajeCobro">Id Mensaje Cobro</span>
          </dt>
          <dd>{estatusEntity.idMensajeCobro}</dd>
          <dt>
            <span id="cc">Cc</span>
          </dt>
          <dd>{estatusEntity.cc}</dd>
          <dt>
            <span id="mt">Mt</span>
          </dt>
          <dd>{estatusEntity.mt}</dd>
          <dt>
            <span id="hs">Hs</span>
          </dt>
          <dd>{estatusEntity.hs}</dd>
          <dt>
            <span id="hp">Hp</span>
          </dt>
          <dd>{estatusEntity.hp}</dd>
          <dt>
            <span id="e">E</span>
          </dt>
          <dd>{estatusEntity.e}</dd>
          <dt>
            <span id="cr">Cr</span>
          </dt>
          <dd>{estatusEntity.cr}</dd>
          <dt>
            <span id="ncVendedor">Nc Vendedor</span>
          </dt>
          <dd>{estatusEntity.ncVendedor}</dd>
          <dt>
            <span id="dvVendedor">Dv Vendedor</span>
          </dt>
          <dd>{estatusEntity.dvVendedor}</dd>
          <dt>
            <span id="tcVendedor">Tc Vendedor</span>
          </dt>
          <dd>{estatusEntity.tcVendedor}</dd>
          <dt>
            <span id="cbVendedor">Cb Vendedor</span>
          </dt>
          <dd>{estatusEntity.cbVendedor}</dd>
          <dt>
            <span id="ciVendedor">Ci Vendedor</span>
          </dt>
          <dd>{estatusEntity.ciVendedor}</dd>
          <dt>
            <span id="nbVendedor">Nb Vendedor</span>
          </dt>
          <dd>{estatusEntity.nbVendedor}</dd>
          <dt>
            <span id="ncClient">Nc Client</span>
          </dt>
          <dd>{estatusEntity.ncClient}</dd>
          <dt>
            <span id="dvClient">Dv Client</span>
          </dt>
          <dd>{estatusEntity.dvClient}</dd>
          <dt>
            <span id="tcClient">Tc Client</span>
          </dt>
          <dd>{estatusEntity.tcClient}</dd>
          <dt>
            <span id="cbClient">Cb Client</span>
          </dt>
          <dd>{estatusEntity.cbClient}</dd>
          <dt>
            <span id="ciClient">Ci Client</span>
          </dt>
          <dd>{estatusEntity.ciClient}</dd>
          <dt>
            <span id="nbClient">Nb Client</span>
          </dt>
          <dd>{estatusEntity.nbClient}</dd>
          <dt>
            <span id="extra1">Extra 1</span>
          </dt>
          <dd>{estatusEntity.extra1}</dd>
          <dt>
            <span id="extra2">Extra 2</span>
          </dt>
          <dd>{estatusEntity.extra2}</dd>
          <dt>
            <span id="extra3">Extra 3</span>
          </dt>
          <dd>{estatusEntity.extra3}</dd>
          <dt>
            <span id="extra4">Extra 4</span>
          </dt>
          <dd>{estatusEntity.extra4}</dd>
          <dt>
            <span id="extra5">Extra 5</span>
          </dt>
          <dd>{estatusEntity.extra5}</dd>
          <dt>
            <span id="extra6">Extra 6</span>
          </dt>
          <dd>{estatusEntity.extra6}</dd>
          <dt>
            <span id="extra7">Extra 7</span>
          </dt>
          <dd>{estatusEntity.extra7}</dd>
          <dt>
            <span id="extra8">Extra 8</span>
          </dt>
          <dd>{estatusEntity.extra8}</dd>
          <dt>
            <span id="extra9">Extra 9</span>
          </dt>
          <dd>{estatusEntity.extra9}</dd>
          <dt>
            <span id="extra10">Extra 10</span>
          </dt>
          <dd>{estatusEntity.extra10}</dd>
          <dt>
            <span id="createdBy">Created By</span>
          </dt>
          <dd>{estatusEntity.createdBy}</dd>
          <dt>
            <span id="createdDate">Created Date</span>
          </dt>
          <dd>
            {estatusEntity.createdDate ? <TextFormat value={estatusEntity.createdDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="lastModifiedBy">Last Modified By</span>
          </dt>
          <dd>{estatusEntity.lastModifiedBy}</dd>
          <dt>
            <span id="lastModifiedDate">Last Modified Date</span>
          </dt>
          <dd>
            {estatusEntity.lastModifiedDate ? (
              <TextFormat value={estatusEntity.lastModifiedDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
        </dl>
        <Button as={Link as any} to="/estatus" replace variant="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button as={Link as any} to={`/estatus/${estatusEntity.id}/edit`} replace variant="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default EstatusDetail;
